import React from "react"
import { Form } from "react-bootstrap";
import styles from "./StepLabel.module.scss";

const StepLabel = ({children}) => {
    return (
        <Form.Row>
            <Form.Label className={styles.stepText}>{children}</Form.Label>
        </Form.Row>
    )
}

export default StepLabel